module.exports = __webpack_public_path__ + "img/KM.953ac29c.png";